import React from 'react';
import useTranslation from '../../../../hooks/use-translation';
import closeIcon from '../../../../images/close.svg';

const styles = {
  buttonContainer: {
    textDecoration: 'none',
    outline: 'none',
    border: 'none',
    background: 'none'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  listItem: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '0.5px solid #3CB5EA',
    marginBottom: '1em',
    padding: '0.2em',
    fontFamily: 'JioType-Medium',
    fontSize: '13px',
    display: 'grid',
    gridTemplateColumns: '1fr 4fr',
    alignItems: 'center',
    width: '100%',
    borderTopRightRadius: '25px',
    borderTopLeftRadius: '25px',
    borderBottomLeftRadius: '25px'

  },
  blueCircle: {
    borderRadius: '50%',
    borderColor: '#3CB5EA',
    background: '#3CB5EA',
    height: '45px',
    width: '45px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#FFFFFF',
    fontSize: '22px'
  }
};

export default ({ close = () => { }, isMobile = false }) => {
  const { t } = useTranslation();
  return (
    <div className={isMobile ? "file-preview-modal-container" : ''}>
      <div className={isMobile ? "file-preview-modal" : ''}>
        <div className="close-file-preview">
          <button style={styles.buttonContainer} onClick={close}><img src={closeIcon} alt="Close Button" /></button>
        </div>
        <div className="file-modal-container">
          <div className="file-modal-header" style={{ marginTop: '-1em' }}>
            <h4>{t("INSTRUCTIONS")}</h4>
          </div>
          <br />
          <div className="file-preview-container flex-direction-column" style={styles.list}>
            {[0, 1, 2, 3, 4, 5].map((key, value) => (
              <div key={key} style={styles.listItem}>
                <div style={styles.blueCircle}>
                  <div>
                    {value + 1}
                  </div>
                </div>
                <div>
                  {t(`INST_${value}`)}
                  {t(`INST_${value}_LINK`) && <a href={`http://${t(`INST_${value}_LINK`)}`} target="_blank" rel="noopener noreferrer">{t(`INST_${value}_LINK`)}</a>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div >
  );
};

